// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"tabbutton_tabButton__gj7ng","active":"tabbutton_active__XyZnf"};